import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import KitAssetQuantityModal from "./KitAssetQuantityModal";

export default function KitAssetQuantity({ disabled, value, onChange, availableQuantity }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="center">
        <TextField disabled value={value} size="small" sx={{ maxWidth: 80 }} />
        {!disabled && (
          <Box ml={1}>
            <Tooltip title="Edit Quantity" placement="top">
              <IconButton onClick={handleOpenModal} size="small">
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Box>
      {isModalOpen && (
        <KitAssetQuantityModal
          onClose={handleCloseModal}
          value={value}
          onChange={onChange}
          availableQuantity={availableQuantity}
        />
      )}
    </>
  );
}
